exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdatetime-time-picker__item--selected {\n  color: #01b1af !important;\n}\n.vdatetime-popup__actions__button {\n  color: #01b1af !important;\n}\n.vdatetime-popup__header {\n  background: #01b1af !important;\n}\n", ""]);

// exports
